<script>
	export let data; // [{x, y},{x, y},..]
	export let width = 45;
	export let height = 20;
	export let color = "blue";
	export let strokeWidth = 2;
	export let lastPointMarker = false;
	export let enableTooltip = false;
  export let tooltipFormatter = null;
  export let yScaleMax = null;
	
	let tooltip;
	let tooltipText = "";
	let cursor;
	let cursorPoint;
	let cursorX = 0;
	let cursorPointY = 0;
	
	$: xMin = Math.min(...data.map(d => d.x));
	$: xMax = Math.max(...data.map(d => d.x));
	$: yMax = yScaleMax ? yScaleMax : Math.max(...data.map(d => d.y));
	$: xRangeMin = strokeWidth;
	$: xRangeMax = width - strokeWidth;
	$: yRangeMin = height - strokeWidth;
	$: yRangeMax = strokeWidth;
	$: dataPoints = data.filter(d => d.y != null).map(d => ({ x: x_scaler(d.x), y: y_scaler(d.y) }));
	$: points = dataPoints.map(p => `${p.x},${p.y}`).join(' ');
	$: lastPoint = dataPoints[dataPoints.length - 1];
	
	$: x_scaler = scale([xMin, xMax], [xRangeMin, xRangeMax]);
	$: y_scaler = scale([0, yMax], [yRangeMin, yRangeMax]);
	$: x_descaler = scale([xRangeMin, xRangeMax], [xMin, xMax]);
	
	function scale(domain, range) {
		let m = (range[1] - range[0]) / (domain[1] - domain[0]);
		if (domain[1] === domain[0]) m = 0;
		return num => range[0] + m * (num - domain[0]);
	}
	
	function showTooltip(e) {
		if (!enableTooltip) return;
		
		let closestPoint = findClosestPoint(e.offsetX);
    if (dataPoints.length < 2 || closestPoint.y == null) {
      hideTooltip();
      return;
    }

		tooltipText = tooltipFormatter ? tooltipFormatter(closestPoint.y) : closestPoint.y;
		tooltip.style.left = e.pageX + 20 + 'px';
		tooltip.style.top = e.pageY + 'px';
		
		cursorX = x_scaler(closestPoint.x);
		cursorPointY = y_scaler(closestPoint.y);
		
		cursor.style.display = "block";
		cursorPoint.style.display = "block";
		tooltip.style.display = "block";
	}
	
	function hideTooltip() {
		cursor.style.display = "none";
		cursorPoint.style.display = "none";
		tooltip.style.display = "none";
	}
	
	function findClosestPoint(pointX) {
		let dataX = x_descaler(pointX);
		return data.reduce((a, b) => distance(a.x, dataX) < distance(b.x, dataX) ? a : b);
	}
	
	function distance(pointX, targetX) {
    return Math.abs(pointX - targetX);
	}
</script>

<svg width={width} height={height} on:mousemove={showTooltip} on:mouseout={hideTooltip} on:blur={hideTooltip}>
  <polyline {points} stroke={color} fill="none" stroke-width={strokeWidth} />
	{#if lastPointMarker}<circle cx={lastPoint?.x} cy={lastPoint?.y} r=2 fill={color} />{/if}
	<line bind:this={cursor} class="tipElement" x1={cursorX} y1=0 x2={cursorX} y2={height} stroke="black" stroke-width=1 />
	<circle bind:this={cursorPoint} class="tipElement" cx={cursorX} cy={cursorPointY} r=2 fill="black" />
</svg>
<div bind:this={tooltip} class="tooltip tipElement">{tooltipText}</div>

<style>
	svg {
		outline: none;
	}
	
	.tooltip {
		position: absolute;
		background-color: rgb(0, 0, 0, .7);
		color: white;
		padding: 2px 6px;
		z-index: 999;
	}
	
	.tipElement {
		display: none;
    pointer-events: none;
	}
</style>